export const isDateLessThanToday = (date: Date) => {
  const currentDate = new Date().setHours(0, 0, 0, 0);
  return new Date(date).setHours(0, 0, 0, 0) < currentDate;
};

export const isDateEqualToToday = (date: Date) => {
  const currentDate = new Date().setHours(0, 0, 0, 0)
  return new Date(date).setHours(0, 0, 0, 0) === currentDate;
};
